import React from "react";
import { useTranslation } from "react-i18next";
import BadgeBoxCst from "@components/BadgeBoxCst";
import {
  EnrollmentStatusSource,
  enrollmentStatusVariant,
  resolveEnrollmentStatusKey,
} from "../../UsersAndGroups/config/enrollmentStatus";

interface ProgressStatusBadgeProps {
  source: EnrollmentStatusSource;
}

const ProgressStatusBadge: React.FC<ProgressStatusBadgeProps> = ({
  source,
}) => {
  const { t } = useTranslation("users-and-groups");
  const statusKey = resolveEnrollmentStatusKey(source);

  return (
    <BadgeBoxCst variant={enrollmentStatusVariant(statusKey)}>
      {t(`card.status.${statusKey}`)}
    </BadgeBoxCst>
  );
};

export default ProgressStatusBadge;
